import React from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { SEOHead } from '../components/SEOHead';
import { Contact } from '../components/Contact';
import { CompanyBanner } from '../components/CompanyBanner';

const SITE = process.env.REACT_APP_SITE_URL || 'https://cajeta-hacienda-real.com';

const contactSchema = (lang, region) => ({
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  '@id': `${SITE}/${region}/contact/#webpage`,
  'url': `${SITE}/${region}/contact`,
  'name': lang === 'es'
    ? 'Contacto – Mayoreo y Distribución | Hacienda Real'
    : 'Contact – Wholesale & Distribution | Hacienda Real',
  'description': lang === 'es'
    ? 'Contacta a Hacienda Real para pedidos al mayoreo, distribución y preguntas sobre cajeta natural de leche de vaca. San Juan de los Lagos, Jalisco, México.'
    : 'Contact Hacienda Real for wholesale orders, distribution, and questions about our natural cow\'s milk cajeta. San Juan de los Lagos, Jalisco, Mexico.',
  'isPartOf': { '@id': `${SITE}/#website` },
  'inLanguage': lang === 'es' ? 'es-MX' : 'en-US',
  'breadcrumb': {
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'name': 'Hacienda Real',
        'item': `${SITE}/${region}`,
      },
      {
        '@type': 'ListItem',
        'position': 2,
        'name': lang === 'es' ? 'Contacto' : 'Contact',
        'item': `${SITE}/${region}/contact`,
      },
    ],
  },
});

export default function ContactPage() {
  const { region = 'mx' } = useParams();
  const { lang } = useLanguage();

  const title = lang === 'es'
    ? 'Contacto – Mayoreo y Distribución de Cajeta Natural'
    : 'Contact – Wholesale & Distribution of Natural Cajeta';
  const description = lang === 'es'
    ? 'Escríbenos para pedidos al mayoreo, distribución y cualquier consulta sobre nuestra cajeta natural de leche de vaca. Hacienda Real, San Juan de los Lagos, Jalisco.'
    : 'Contact us for wholesale orders, distribution inquiries, and questions about our natural cow\'s milk cajeta. Hacienda Real, San Juan de los Lagos, Jalisco, Mexico.';

  return (
    <>
      <SEOHead
        title={title}
        description={description}
        canonical={`/${region}/contact`}
        lang={lang}
        altLang={{ es: '/mx/contact', en: '/us/contact' }}
        schema={contactSchema(lang, region)}
      />
      <CompanyBanner />
      <Contact />
    </>
  );
}
